<template>
  <div>
    <!-- 头部 -->

    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" style="margin-top: 20px; heigth: 60px">
      <el-form-item label="搜索：">
        <el-input size="small" v-model="formInline.vin" placeholder="请输入车辆编号" clearable></el-input>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button size="small" type="success" icon="el-icon-plus" @click="importCar"
          v-if="check_auth('/web/area/get_cars')">添加车辆</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table class="elTable" size="small" :data="listData" highlight-current-row v-loading="loading" border
      element-loading-text="拼命加载中" style="width: 100%">
      <el-table-column align="center" prop="vin" label="车辆编号"></el-table-column>
      <el-table-column align="center" prop="code" label="车辆型号"></el-table-column>
      <el-table-column align="center" prop="car_number" label="车牌号"></el-table-column>
      <el-table-column align="center" fixed="right" label="操作" width="180" v-if="check_auth('/web/area/del_area_car')">
        <template slot-scope="scope">
          <el-button size="mini" type="danger" @click="delCar(scope.row)" round
            v-if="check_auth('/web/area/del_area_car')">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <!-- 添加界面 -->
    <el-dialog title="添加" :visible.sync="dialogTableVisible" @click="closeDialog" :destroy-on-close="true"
      :close-on-click-modal="false">
      <el-form :inline="true" :model="importInline" class="user-search1">
        <el-form-item label="搜索：">
          <el-input size="small" v-model="importInline.vin" placeholder="请输入车辆编号"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" icon="el-icon-search" @click="searchCar">搜索</el-button>
        </el-form-item>
      </el-form>
      <el-table :data="gridData" @selection-change="handleSelectionChange" ref="multipleTable" row-key="id">
        <el-table-column width="50" type="selection" reserve-selection></el-table-column>
        <el-table-column align="center" prop="id" label="ID" width="80">
          <template slot-scope="scope">
            <span v-text="scope.$index + 1"></span>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="vin" label="车辆编号"></el-table-column>
        <el-table-column align="center" prop="name" label="车辆名称"></el-table-column>
        <el-table-column align="center" prop="car_number" label="车牌号"></el-table-column>
        <el-table-column align="center" prop="code" label="车辆型号"></el-table-column>
      </el-table>
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page="pagetwo.currentPage" :page-size="pagetwo.pageSize" background :pager-count="5"
        layout="prev, pager, next" :total="pagetwo.total">
      </el-pagination>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeDialog">取 消</el-button>
        <el-button type="primary" @click="addImport">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  get_area_car_list,
  get_area_car_add,
  get_area_bind_cars,
  del_area_car,
} from "../../api/region/area_car";
import Pagination from "../../components/Pagination";
import {
  auth
} from "../../utils/util";
export default {
  name: "car",
  data() {
    return {
      nshow: true, //switch开启
      fshow: false, //switch关闭
      loading: false, //是显示加载
      dialogTableVisible: false,
      idsval: [],
      ids: [],
      gridData: [],
      formInline: {
        page: 1,
        limit: 10,
        vin: "",
      },
      importInline: {
        vin: "",
        page: 1,
        limit: 10,
      },
      userparm: [], //搜索权限
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10,
      },
      // 导入车辆分页参数
      pagetwo: {
        currentPage: 1,
        pageSize: 10,
        total: 10,
      },
    };
  },

  // 注册组件
  components: {
    Pagination,
  },
  /**
   * 创建完毕
   */
  // created() {
  //   this.getCarData();
  // },
  mounted() {
    this.$nextTick(function () {
      this.$on("childmethod", function () {
        this.getCarData();
      });
    });
    // this.getCarData();
  },
  methods: {
    childmethod() { },
    // 获取公司列表
    getCarData() {
      get_area_car_list(this.formInline).then((res) => {
        if (res["code"] === 0) {
          this.listData = res.data.data;
          this.pageparm.currentPage = this.formInline.page;
          this.pageparm.pageSize = this.formInline.limit;
          this.pageparm.total = res.data["total"];
        }
      });
    },
    check_auth(val) {
      return auth(val);
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage;
      this.formInline.limit = parm.pageSize;
      this.getCarData();
    },
    // 搜索事件
    search() {
      this.formInline.page = 1;
      this.getCarData();
    },
    getImport() {
      get_area_car_add(this.importInline).then((res) => {
        this.gridData = res.data.data;
        this.pagetwo.currentPage = this.importInline.page;
        this.pagetwo.pageSize = this.importInline.limit;
        this.pagetwo.total = res.data["total"];
      });
    },
    // 搜索车辆
    searchCar() {
      this.importInline.page = 1;
      this.getImport();
    },
    callcar() {
      this.importInline.page = this.pagetwo.currentPage;
      this.importInline.limit = this.pagetwo.pageSize;
      this.getImport();
    },
    // 显示导入车辆界面
    importCar() {
      this.ids = [];
      this.dialogTableVisible = true;
      this.importInline.page = 1;
      this.getImport();
      this.toggleRowSelect();
    },
    //导入车辆id
    handleSelectionChange(val) {
      this.idsval = [];
      for (let i in val) {
        //去重以免发生意外的push
        if (!this.idsval.includes(val[i])) {
          this.idsval.push(val[i]);
        }
      }
    },
    toggleRowSelect() {
      var that = this;
      that.$nextTick(() => {
        if (that.$refs.multipleTable) {
          that.$refs.multipleTable.clearSelection();
        }
      });
    },
    //导入数据
    addImport() {
      this.dialogTableVisible = false;
      for (var i = 0; i < this.idsval.length; i++) {
        this.ids.push(this.idsval[i].vin);
      }
      var strs = this.ids.join(",");
      get_area_bind_cars(strs).then((res) => {
        if (res["code"] === 0) {
          this.getCarData();
          this.$message.success(res["message"]);
          this.ids = [];
        }
      });
    },
    // 删除公司
    delCar(row) {
      this.$confirm("确定要删除吗?", "信息", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          del_area_car(row.vin).then((res) => {
            if (res["code"] === 0) {
              this.$message.success(res["message"]);
              if (this.listData.length === 1) {
                if (this.formInline.page === 1) {
                  this.getCarData();
                } else {
                  this.formInline.page = this.formInline.page - 1;
                  this.getCarData();
                }
              } else {
                this.getCarData();
              }
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    handleSizeChange(val) {
      this.pagetwo.pageSize = val;
      this.callcar();
    },
    handleCurrentChange(val) {
      this.pagetwo.currentPage = val;
      this.callcar();
    },
    // 关闭编辑、增加弹出框
    closeDialog() {
      this.dialogTableVisible = false;
    },
  },
};
</script>
<style scoped></style>


// WEBPACK FOOTER //
// src/views/region_mn/area_car.vue